<template>
  <div class="card-item card-item-activity">
    <icon-activity class="icon" v-ifield-b-tooltip="iconTooltipText" />
    <span
      ref="truncTarget"
      class="text ellipsis"
      v-ifield-b-tooltip="tooltipOption"
    >
      {{ text }}
    </span>
  </div>
</template>

<script>
import { toRefs } from 'vue'
import IconActivity from '@/assets/ifield/ic_operating-status.svg?component'
import { useIsTruncated } from '@/composables/UseIsTruncated'
import { useUserStatusAdditionalItemActivity } from '@/composables/user/additionalItem'

export default {
  name: 'AppCardMemberItemActivity',
  components: {
    IconActivity,
  },
  inheritAttrs: false,
  props: {
    /**
     * アクティビティ値
     */
    value: {
      type: String,
      default: null,
    },
    /**
     * 変更日時
     */
    changeAt: {
      type: String,
      default: null,
    },
    /**
     * 基準日時
     * * 経過日数表記を更新したい場合は値を変更する
     * * binding されない場合、経過日数はマウント時の現在時刻での計算以降変化しない
     */
    baseDate: {
      type: Date,
      default: null,
    },
  },
  setup(props) {
    const { value, changeAt, baseDate } = toRefs(props)
    const { truncTarget, isTruncated } = useIsTruncated()
    const { text } = useUserStatusAdditionalItemActivity({
      value,
      changeAt,
      baseDate,
    })
    return { truncTarget, isTruncated, text }
  },
  computed: {
    /**
     * アイコン部ツールチップテキスト
     * @type {string}
     */
    iconTooltipText: function () {
      return `${this.$t('appCardMemberItemActivity.activity')} : ${this.text}`
    },
    /**
     * テキスト部ツールチップオプション
     * @type {Object}
     */
    tooltipOption: function () {
      return {
        title: this.text,
        disabled: !this.isTruncated,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@use '../../../assets/scss/parts/member/card-member-item';
</style>
